import { Injectable } from '@angular/core';
import { keys } from '@sama/micro-dash';
import { UnzipService } from '../../../../cross-team-shared/asset-loading/unzip.service';
import { ObjectWith } from '../../../../cross-team-shared/types/misc';
import { EventTrackingValue } from '../../../../team-apis/core/event-tracking';

@Injectable({ providedIn: 'root' })
export class VideoUnzipService extends UnzipService {
  protected override collateBlobUrls(unzippedBlobUrls: ObjectWith<string>) {
    const sensorFrames = keys(unzippedBlobUrls)
      .sort()
      .map((key) => ({ imageUrl: unzippedBlobUrls[key] }));
    const eventTrackingValue: EventTrackingValue = {
      frame_count: sensorFrames.length,
      type: 'video',
    };
    return { sensorFrames, eventTrackingValue };
  }
}
